import React, { Component } from 'react';
import { connect } from 'react-redux';

import moment from 'moment';

import { getIcon } from '../../util/icons';

import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

class UpdateSprintDatesModal extends Component{

  //moments
  state = {
    startDate: null,
    endDate: null,
  }

  componentWillMount(){

    const { startDate, endDate } = this.props;

    console.log('rendering with startdate: ', startDate);

    this.setState({
      startDate: moment(startDate),
      endDate: moment(endDate),
      focusedInput: null
    });

    this.hide = this.hide.bind(this);
    this.updateDates = this.updateDates.bind(this);
  }

  hide(){
    this.props.hide();
  }
  updateDates(){
    const { startDate, endDate } = this.state;
    this.props.onUpdateDates(startDate.valueOf(), endDate.valueOf());
  }

  updateLocalDates({startDate, endDate}){
    this.setState({
      startDate,
      endDate
    });
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    const { startDate, endDate } = this.state;

    return (
      <div className="modal">
        <div className="modal-container">
          <div className="close-icon" onClick={this.hide}>X</div>
          <div className="modal-content">
            <div className="message-icon">{getIcon('calendar')}</div>
            <div className="message">
              <p>Select sprint date range...</p>
              <DateRangePicker
                hideKeyboardShortcutsPanel={true}
                isOutsideRange={() => false}
                startDate={startDate}
                endDate={endDate}
                startDateId={'update-sprint-start-date'}
                endDateId={'update-sprint-end-date'}
                onDatesChange={this.updateLocalDates.bind(this)}
                focusedInput={this.state.focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                />
            </div>
          </div>
          <div className="modal-actions">
            <button onClick={this.updateDates} className="button primary">Update</button>
            <button onClick={this.hide} className="button grey-outline">Cancel</button>
          </div>
        </div>
      </div>
    )
  }
}

export default UpdateSprintDatesModal;



// WEBPACK FOOTER //
// ./src/components/modals/updateSprintDates.js